export const GetTime = (time: number) => {
  // if (time < 0) window.location.reload()
  const hours = Math.trunc(time / 1000 / 3600)
  const minutes = Math.trunc((time / 1000 % 3600) / 60)
  const seconds = Math.trunc((time / 1000 % 3600) % 60)

  return `${hours}h ${minutes}m ${seconds}s`
}